import React from "react";
import { Outlet } from "react-router";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import LanguageProvider from "../context/LanguageContext";
import ScrollToSection from "./header/useScrollToHash";
const Layout = () => {
  return (
    <LanguageProvider>
    <div className="wrapper">
         <ScrollToSection/>
      <div className="inner_wrapper d-flex flex-column min-vh-100">
        <Header/>
        <div className="flex-grow-1">
        <Outlet />
        </div>
       <Footer/>
      </div>
    </div>
    </LanguageProvider>
  );
};

export default Layout;